/* --------------------------------------------------------------------------------------
   xwScrollable.directive.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

/*eslint semi: ["error", "never"]*/
 export class xwScrollable {
  /*@ngInject*/
  constructor () {
    this.restrict = 'A'
    this.scope = {}
  }
  link(scope, elem, attrs) {
    const element = elem.first()
    const options = {
      zoom: (attrs.zoom == "true"),
      tap: (attrs.tap == "true"),
      height: attrs.height,
      width: attrs.width,
      noScrollIndicator: (attrs.noScrollIndicator == true)
    }
    setTimeout(element.xrxscrollable(options),100)


    attrs.$observe('zoomLevel', (val) => {
        element.xrxscrollable('getIScroll').zoom(val)
    });

    scope.$on('$destroy', () => {
      scope = null
    })
    elem.on('$destroy', () => {
      element.xrxscrollable('destroy')
      elem = null
    })
  }
  static directiveFactory() {
    xwScrollable.instance = new xwScrollable()
    return xwScrollable.instance
  }
}



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xwScrollable.directive.js